module.exports = __webpack_public_path__ + "img/ico_user.546658a8.png";